<template>
  <b-card>
    <ChangeTeamZoneConfirmation
      :new-zone="newZoneSelected"
      :team-id="teamId"
      @refresh="onZoneChangedHandler"
    />
    <DeleteTeamModal
      :team="teamDetails"
      @team-deleted="teamDeletedHandler"
    />
    <DeleteTeamMemberModal
      :member="selectedTeamMember"
      @member-deleted="fetchTeamDetails"
    />
    <UpgradeTeamLevelModal
      :team-id="teamId"
      @level-upgraded="onLevelUpgraded"
    />
    <levelActionRewards
      :id="rankId"
      :action="action"
      @done="fetchTeamRewards"
    />
    <b-row>
      <b-col md="12">
        <div class="d-flex align-items-center justify-content-between">

          <!-- <div
            v-if="teamProggress!= null && teamProggress!= undefined"
            class="d-flex align-items-center"
          >
            <h4 class="font-weight-bold mr-1">
              Total Progress:
            </h4>
            <h4>
              {{ teamProggress }}
            </h4>
          </div> -->
          <div class="d-flex align-items-center" style="gap: 0.5rem">
            <b-button
              v-if="$can('write', 'teams')"
              variant="primary"
              @click="showUpgradeLevelModal"
            >
              Upgrade Level
            </b-button>
            <b-button
              v-if="$can('write', 'teams')"
              variant="danger"
              @click="showDeleteModal"
            >
              Delete Team
            </b-button>
          </div>
        </div>
      </b-col>
    </b-row>
    <base-overlay :show="fetching">
      <b-row
        v-if="teamDetails"
      >
        <b-col md="12">
          <div
            class="mt-1 d-flex flex-column"
            style="gap:1rem"
          >
            <div class="d-flex align-items-center">
              <span class="font-weight-bold mr-1">Name English: </span>
              <span>
                {{ teamDetails.name.en }}
              </span>
            </div>
            <div class="d-flex align-items-center">
              <span class="font-weight-bold mr-1">Name Arabic: </span>
              <span>
                {{ teamDetails.name.ar }}
              </span>
            </div>
            <div class="d-flex align-items-center">
              <span class="font-weight-bold mr-1">Creator Name: </span>
              <span>
                {{ teamDetails.creator.name }}
              </span>
            </div>
            <div class="d-flex align-items-center">
              <span class="font-weight-bold mr-1">Zone: </span>
              <span class="mr-1">
                {{ teamZone }}
              </span>
              <b-button
                v-if="!editZoneMode"
                class="btn-icon rounded-circle"
                variant="flat-primary"
                @click="editZoneMode = true"
              >
                <feather-icon
                  size="12"
                  icon="EditIcon"
                />
              </b-button>
              <div
                v-else
                class="d-flex align-items-center"
              >
                <div
                  style="width:300px"
                >
                  <ZonesSearch
                    placeholder="Search zones"
                    @zone-selected="onZoneSelected"
                  />
                </div>
                <b-button
                  class="btn-icon rounded-circle"
                  variant="flat-danger"
                  @click="editZoneMode = false"
                >
                  <feather-icon
                    size="12"
                    icon="XIcon"
                  />
                </b-button>
              </div>
            </div>
            <div class="d-flex align-items-center">
              <span class="font-weight-bold mr-1">Rank Level:</span>
              <span>
                {{ teamDetails.rank.level }}
              </span>
            </div>
            <div class="d-flex align-items-center">
              <span class="font-weight-bold mr-1">Rank Capacity:</span>
              <span>
                {{ teamDetails.rank.capacity }}
              </span>
            </div>
            <div class="d-flex align-items-center">
              <span class="font-weight-bold mr-1">Creator Phone No:</span>
              <span>
                {{ teamDetails.creator.phoneNumber }}
              </span>
            </div>
            <div class="d-flex align-items-center">
              <span class="font-weight-bold mr-1">Description En: </span>
              <span>
                {{ teamDetails.description ? teamDetails.description.en : '' }}
              </span>
            </div>
            <div class="d-flex align-items-center">
              <span class="font-weight-bold mr-1">Description Ar: </span>
              <span>
                {{ teamDetails.description ? teamDetails.description.ar : '' }}
              </span>
            </div>
          </div>
        </b-col>
        <b-col md="12">
          <TeamsHistoricalData :team-id="teamId" />
        </b-col>

        <b-col
          v-if="teamProggress!= null && teamProggress!= undefined"
          md="12"
          class="my-2"
        >
          <b-tabs>
            <b-tab title="Overall Progress">
              <TeamOverallProgress :stats="teamProggress" />
            </b-tab>
            <b-tab title="Team Members Progress">
              <TeamMemberProgress
                :kpi-progress="teamProggress.kpiProgress"
                :team-members="teamMembers"
                :team-id="teamId"
              />
            </b-tab>
          </b-tabs>
        </b-col>
        <b-col
          md="12"
          class="mt-2"
        >
          <h4>Team Members</h4>
          <b-table
            :fields="membersCols"
            :items="teamMembers"
          >
            <template #cell(actions)="data">
              <b-button
                variant="flat-primary"
                @click="showDriver(data.item)"
              >
                <feather-icon icon="EyeIcon" />
              </b-button>
              <b-button
                v-if="data.item.role != 'LEADER'"
                variant="flat-danger"
                @click="deleteTeamMember(data.item)"
              >
                <feather-icon icon="TrashIcon" />
              </b-button>
            </template>
          </b-table>
        </b-col>
        <b-col
          md="12"
          class="mt-2"
        >
          <h4>Team Levels & Rewards</h4>
          <base-overlay :show="fetchingRewards">
            <b-table
              v-if="teamRewards"
              :fields="levelsColumns"
              :items="teamRewards"
              responsive
              striped
              bordered
              show-empty
              empty-text="No records found"
              class="text-center"
            >
              <template #cell(actions)="row">
                <div v-if="row.item.state === 'COMPLETED' && row.item.rewardsState === 'PENDING'">
                  <b-button
                    class="mr-1"
                    size="sm"
                    variant="primary"
                    @click="applyActionOnLevel(row.item.id, 'PROCESS')"
                  >
                    Approve
                  </b-button>
                  <b-button
                    size="sm"
                    variant="danger"
                    @click="applyActionOnLevel(row.item.id, 'REJECT')"
                  >
                    Reject
                  </b-button>
                </div>
              </template>
              <template
                #cell(rewards)="row"
              >
                <b-form-checkbox
                  v-if="row.item.rewards.length"
                  v-model="row.detailsShowing"
                  @change="row.toggleDetails"
                >
                  <span class="message_style">{{ row.detailsShowing ? 'Hide' : 'Show' }} Rewards</span>
                </b-form-checkbox>
                <span v-else>No rewards to be shown</span>

              </template>
              <template
                #row-details="row"
              >
                <b-table
                  :fields="rewardsColumns"
                  :items="row.item.rewards"
                  responsive
                  striped
                  bordered
                  show-empty
                  empty-text="No rewards found"
                  class="text-center"
                />
              </template>
            </b-table>
          </base-overlay>
        </b-col>
      </b-row>
    </base-overlay>
  </b-card>
</template>

<script>
import { computed, ref } from '@vue/composition-api'
import {
  BCard, BRow, BCol, BTable, BButton, BFormCheckbox, BTabs, BTab,
} from 'bootstrap-vue'
import axiosIns from '@/libs/axios'
import BaseOverlay from '@/UI/BaseOverlay.vue'
import DeleteTeamModal from '../components/DeleteTeamModal.vue'
import DeleteTeamMemberModal from '../components/DeleteTeamMember.vue'
import UpgradeTeamLevelModal from '../components/UpgradeTeamLevelModal.vue'
import levelActionRewards from '../components/level-action-rewards.vue'
import TeamOverallProgress from '../components/TeamOverallProgress.vue'
import TeamMemberProgress from '../components/TeamMemberProgress.vue'
import ZonesSearch from '@/views/zones/components/ZonesSearch.vue'
import ChangeTeamZoneConfirmation from '../components/ChangeTeamZoneConfirmation.vue'
import TeamsHistoricalData from '../components/TeamsHistoricalData.vue'

export default {
  components: {
    BCard,
    TeamOverallProgress,
    TeamMemberProgress,
    ZonesSearch,
    BFormCheckbox,
    ChangeTeamZoneConfirmation,
    BaseOverlay,
    TeamsHistoricalData,
    BRow,
    levelActionRewards,
    BCol,
    BButton,
    DeleteTeamModal,
    DeleteTeamMemberModal,
    UpgradeTeamLevelModal,
    BTable,
    BTabs,
    BTab,
  },
  setup(_, ctx) {
    const teamId = ctx.root.$route.params.id
    const teamDetails = ref()
    const fetching = ref(false)
    const membersCols = [
      {
        label: 'name',
        key: 'name',
      },
      {
        label: 'Phone Number',
        key: 'phoneNumber',
      },
      {
        label: 'Role',
        key: 'role',
      },
      {
        label: '',
        key: 'actions',
      },
    ]

    const teamProggress = ref()

    const fetchTeamProggress = async () => {
      const result = await axiosIns.get(`/teams/progress/${teamId}`)
      teamProggress.value = result.data
    }
    const fetchTeamDetails = async () => {
      fetching.value = true
      const result = await axiosIns.get(`/teams/${teamId}`)
      teamDetails.value = result.data.data
      fetching.value = false
    }

    const fetchingRewards = ref(false)
    const teamRewards = ref()
    const levelsColumns = [
      {
        key: 'rewards',
        label: '',
      },
      {
        label: 'Level Name EN',
        key: 'nameEn',
        formatter: (_1, _2, item) => item.level.name.en,
      },
      {
        label: 'Level Name AR',
        key: 'nameAr',
        formatter: (_1, _2, item) => item.level.name.ar,
      },
      'actions',
    ]
    const rewardsColumns = [
      {
        label: 'Reward Name EN',
        key: 'nameEn',
        formatter: (_1, _2, item) => item.name.en,
      },
      {
        label: 'Reward Name AR',
        key: 'nameAr',
        formatter: (_1, _2, item) => item.name.ar,
      },
    ]

    const fetchTeamRewards = async () => {
      fetchingRewards.value = true
      const result = await axiosIns.get(`/teams/pending-rewards?teamId=${teamId}`)
      teamRewards.value = result.data
      fetchingRewards.value = false
    }

    const teamMembers = computed(() => teamDetails.value?.members || [])

    const fetchData = () => {
      fetchTeamDetails()
      fetchTeamProggress()
      fetchTeamRewards()
    }

    fetchData()

    const showDriver = driver => {
      window.open(`/drivers/${driver.id}?externalId=${driver.externalId}`)
    }

    const teamDeletedHandler = () => {
      ctx.root.$router.push('/teams')
    }

    const showDeleteModal = () => {
      ctx.root.$bvModal.show('delete-team-modal')
    }

    const selectedTeamMember = ref()
    const deleteTeamMember = member => {
      selectedTeamMember.value = member
      ctx.root.$bvModal.show('delete-team-member-modal')
    }

    const action = ref('')
    const rankId = ref('')
    const applyActionOnLevel = async (rankIdVal, actionVal) => {
      action.value = actionVal
      rankId.value = rankIdVal
      ctx.root.$bvModal.show('level-rewards-modal')
    }

    const teamZone = computed(() => teamDetails.value?.zone.split('::')[1])
    const editZoneMode = ref(false)
    const newZoneSelected = ref('')

    const onZoneSelected = zone => {
      newZoneSelected.value = zone
      ctx.root.$bvModal.show('confirm-zone-change-modal')
    }

    const onZoneChangedHandler = () => {
      fetchData()
      editZoneMode.value = false
      newZoneSelected.value = ''
    }

    const showUpgradeLevelModal = () => {
      ctx.root.$bvModal.show('upgrade-team-level-modal')
    }

    const onLevelUpgraded = () => {
      fetchData()
    }

    return {
      newZoneSelected,
      action,
      rankId,
      teamDetails,
      fetching,
      showDeleteModal,
      showUpgradeLevelModal,
      editZoneMode,
      selectedTeamMember,
      membersCols,
      applyActionOnLevel,
      deleteTeamMember,
      teamProggress,
      fetchTeamDetails,
      rewardsColumns,
      fetchingRewards,
      fetchTeamRewards,
      teamId,
      levelsColumns,
      teamRewards,
      teamDeletedHandler,
      showDriver,
      fetchData,
      teamMembers,
      onZoneSelected,
      teamZone,
      onZoneChangedHandler,
      onLevelUpgraded,
    }
  },
}
</script>
